<template>
  <div class="form-detail">
    <h1>{{ title }}</h1>
    <template v-if="!isLoading">
      <div v-for="objKey in fields" :key="objKey.key">
        <div class="form-group form-row mb-2">
          <div class="col-sm-12 border-row">
            <label for="" class="col-sm-4 pl-1 col-form-label">
              {{ objKey.label }}
            </label>
            <div class="col-sm-8">
              <p class="form-control-plaintext d-flex align-items-center f12">
                <span class="mr-1">:</span>
                <slot :name="objKey.key" :value="valueInfo[objKey.key]">
                  {{ valueInfo[objKey.key] }}
                </slot>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="spinner-center">
        <b-spinner class="align-middle" />
      </div>
    </template>
  </div>
</template>

<style scoped>
  .spinner-center {
    display: flex;
    justify-content: center;
  }

  .border-row {
    display: flex;
  }
  .form-detail h1 {
    border-bottom: 1px solid #e9e9e9;
  }
  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }
</style>

<script>
  import { flatObject } from '@/utils/util'

  export default {
    // props: ['title', 'info', 'isLoading', 'keyNames'],
    props: {
      title: {
        type: String,
        default: 'Thông tin chung',
      },
      info: Object,
      isLoading: {
        type: Boolean,
        default: false,
      },
      fields: Array,
    },
    computed: {
      valueInfo() {
        return flatObject(this.info || {})
      },
    },
  }
</script>
